/**
 * Image Gallery - Lightbox JS
 *
 * @since   1.0.0
 * @package lighting-pros
 */

(function($) {
	$(document).ready(function() {

		if ($('.image-gallery').length) {

			var overlay = document.querySelector('.overlay');
			var overlayImage = overlay.querySelector('img');
			var overlayClose = overlay.querySelector('.overlay-close');
			var $galleryImgs = document.querySelectorAll('.gallery-img');

			function handleClick(e) {
				var src = e.currentTarget.querySelector('img').src;
				overlayImage.src = src;
				overlay.classList.add('open');
			}

			function close(e) {
				if (e.target !== overlayImage) {
					overlay.classList.remove('open');
				}
			}

			for (var i = 0; i < $galleryImgs.length; i++) {
				$galleryImgs[i].addEventListener('click', handleClick)
			}

			overlay.addEventListener('click', close);

		}

	}); // document.ready
})(jQuery);
